import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import {
  LoadIcon, InstructionIcon,
} from '../Styled/Buttons/icons';
import { mapStateAuth, withAuthConsumer } from '../../providers/authProvider';
import Dashboards from '../../containers/dashbards';

const Container = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
`;
const ContainerLink = styled.div`
  display: flex;
  align-items: center;
`;
const StyledLink = styled(Link)`
  margin-left: 0.3em;
  color: #488de4;
  font-size: 1em;
  &:hover{
    color: #1a4aac;
  };
  &:visited{
    color: #3f51b4;
  };
`;
const StyledDownload = styled.a`
  margin-left: 0.3em;
  color: #488de4;
  font-size: 1em;
  &:hover{
    color: #1a4aac;
  };
  &:visited{
    color: #3f51b4;
  };
`;

function Home() {
  return (
    <Container className="fullscreenParent">
      <div style={{ display: 'flex' }}>
        <ContainerLink>
          <img width="20px" src={LoadIcon} alt="LoadIcon" />
          <StyledLink to="/srv/exchange/create">Завантажити виписку</StyledLink>
        </ContainerLink>
        <ContainerLink style={{ marginLeft: '10px' }}>
          <img width="20px" src={InstructionIcon} alt="LoadIcon" />
          <StyledDownload href="https://www.ciat.net.ua/media/cms_page_media/14/UsersManual.be2d5421.doc" download>
            Довідник користувача
          </StyledDownload>
        </ContainerLink>
      </div>
      <Dashboards />
      {/* <ReportLister /> */}
    </Container>
  );
}

Home.propTypes = {
  currentUser: PropTypes.shape({
    org: PropTypes.shape({
      hide_e: PropTypes.bool,
    }),
  }).isRequired,
};

export default withAuthConsumer(mapStateAuth)(Home);
